import { Modal, TextField, Button } from "@mui/material";
import styled from "styled-components";
import { useState, useEffect } from "react";
import BasicTitle from "../title";
import ModalExitWithoutSaving from "./modalExitWithoutSaving";
import Api from "../../libs/api";
import Storage from "../../libs/storage";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 632px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 800px) {
        margin-right: 16px;
        width: calc(100% - 32px);
    }
`;

const ModalClose = styled.img`
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
    z-index: 10;
    width: 24px;
    height: 24px;
`;

const ModalContent = styled.div`
    display: flex;
    padding: 40px;
`;

const Content = styled.div`
    flex: 1;
`;

const Text = styled.p`
    color: #181122;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 133%;
    letter-spacing: -0.14px;
    margin-bottom: 24px;
`;

const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    margin-bottom: 24px;
`;

const SubTitle = styled.div`
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #181122;
    text-transform: uppercase;
    width: 100%;
    margin-bottom: 5px;
`;

const PrimaryButton = styled(Button)`
    && {
        background: #57c4c2;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 24px;
        border-radius: 8px;
        width: 100%;
        text-transform: uppercase;

        &:hover {
            background: #4ba09b;
        }

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const ModalResetPassword = ({ open, onClose, user, impersonateCompanyId }) => {
    const api = Api();
    const storage = Storage();
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState(user?.email);
    const [exitModalOpen, setExitModalOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setEmail(user?.email);
    }, [user]);

    const handleClose = () => {
        if (step === 2) {
            setExitModalOpen(true);
        } else {
            onClose();
        }
    };

    const handleConfirmExit = () => {
        setExitModalOpen(false);
        setStep(1);
        setPassword('');
        setError('');
        onClose();
    };

    const handleSave = async () => {
        if (step === 1) {
            setLoading(true);
            setError('');
            try {
                const data = await storage.getItem('data');
                const result = await api.resetAdminPassword(data.token, user.id, impersonateCompanyId);
                const newPassword = result.data.resetPasswordAdmin.resetPasswordAdmin.newPassword;
                setPassword(newPassword);
                setStep(2);
            } catch (err) {
                setError(err.message || 'Erro ao resetar a senha. Tente novamente.');
            } finally {
                setLoading(false);
            }
        } else {
            navigator.clipboard.writeText(password);
            setStep(1);
            setPassword('');
            onClose();
        }
    };

    return (
        <>
        <Modal
            open={open && !exitModalOpen}
            onClose={handleClose}
        >
            <ModalCenter style={{ overflowY: "auto", maxHeight: "95%", padding: 0, border: 0 }}>
                <ModalClose
                    src="/img/modal_close.svg"
                    onClick={handleClose}
                />
                <ModalContent>
                    <Content>
                        <BasicTitle showLine title='Resetar senha do usuário' margin={24}/>
                        {step === 1 && (
                            <Text>
                                Uma nova senha será gerada e deverá ser enviada ao usuário manualmente. Deseja continuar?
                            </Text>
                        )}
                        <FieldContainer>
                            {step === 1 ? (
                                <>
                                    <SubTitle>E-MAIL do usuário</SubTitle>
                                    <TextField
                                        id="outlined-basic"
                                        value={email}
                                        variant="outlined"
                                        style={{ borderRadius: 5, cursor: 'not-allowed' }}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                        }}
                                        disabled={true}
                                    />
                                </>
                            ) : (
                                <>
                                    <SubTitle>Senha</SubTitle>
                                    <TextField
                                        id="outlined-basic"
                                        value={password}
                                        variant="outlined"
                                        style={{ borderRadius: 5, cursor: 'not-allowed' }}
                                        disabled={true}
                                    />
                                </>
                            )}
                        </FieldContainer>
                        <PrimaryButton onClick={handleSave} disabled={loading}>
                            {step === 1 ? (loading ? 'Aguarde...' : 'Sim, resetar a senha') : 'Copiar a senha'}
                        </PrimaryButton>
                        {error && (
                            <p style={{ color: '#DE6061', fontSize: 13, marginTop: 12 }}>{error}</p>
                        )}
                    </Content>
                </ModalContent>
            </ModalCenter>
        </Modal>
        <ModalExitWithoutSaving
            open={exitModalOpen}
            onClose={handleConfirmExit}
            onConfirmExit={handleConfirmExit}
            onGoBack={() => setExitModalOpen(false)}
        />
        </>
    );
}

export default ModalResetPassword;

